import { ResourceOptions } from 'react-admin';
import { MdOutlineGeneratingTokens } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xpxPerpsTokenConfigs;
export const icon = MdOutlineGeneratingTokens;
export const options: ResourceOptions = {
  label: 'module.xpxPerpsTokenConfigs.title',
};
